
// Analytics implementation
export const USER_ROLE = 'User_Role';
export enum EVENT {
  UE_CARRIERREQ_PRESENTED = "ue_carrierreq_presented",
  UE_GUEST_CARRIERREQ_PRESENTED = "ue_guest_carrierreq_presented",
  UE_CARRIERREQ_AGREED = "ue_carrierreq_agreed",
  UE_GUEST_CARRIERREQ_AGREED = "ue_guest_carrierreq_agreed",
  UE_CARRIERREQ_FAILURE = "ue_carrierreq_failure",
  UE_GUEST_CARRIERREQ_FAILURE = "ue_guest_carrierreq_failure",
  UE_CARRIERREQ_NOTNOW = "ue_carrierreq_notnow",
  UE_GUEST_CARRIERREQ_NOTNOW = "ue_guest_carrierreq_notnow",
  SV_HOME = "sv_home",
  UE_VIEW_RECOMMENDED_TAB = "ue_view_recommended_tab",
  UE_SCROLL_RECOMMENDATIONS = "ue_scroll_recommendations",
  UE_DOC_SUBMISSION_SUCCESS = "ue_doc_submission_success",
  UE_DOC_SUBMISSION_FAILURE = "ue_doc_submission_failure",
  UE_DOC_VIEW = "ue_doc_view",
  //Added for LPE Feedback
  UE_VIEW_RECOMMENDED_SIMILAR_LOADS = 'ue_view_recommended_similar_loads',
  UE_VIEW_WATCHED_TAB = "ue_view_watched_tab",
  SV_GET_STARTED = 'sv_get_started',
  SV_REGISTRATION = 'sv_registration',
  UE_REGISTER_NOW = 'ue_register_now',
  UE_REGISTER_SUCCESS = 'ue_register_success',
  UE_GUEST_REGISTER_SUCCESS = 'ue_guest_register_success',
  UE_REGISTER_FAILURE = 'ue_register_failure',
  UE_GUEST_REGISTER_FAILURE = 'ue_guest_register_failure',
  UE_SIGN_IN = 'ue_sign_in',
  UE_LOGIN_SUCCESS = 'ue_login_success',
  UE_GUEST_LOGIN_SUCCESS = "ue_guest_login_success",
  UE_LOGIN_FAILED = 'ue_login_failed',
  //Search
  SV_SEARCH_FILTER = 'sv_search_filter',
  SV_SEARCH_RESULT = 'sv_search_result',
  SV_VIEW_LOAD = 'sv_view_load',
  UE_SEARCH_SEE_RESULTS = 'ue_search_see_results',
  //Book It Now
  UE_BOOK_LOAD_NOW = 'ue_book_load_now',
  SV_LOAD_DETAILS_RATE = 'sv_load_details_rate',
  UE_LOAD_RATE_ACCEPT = 'ue_load_rate_accept',
  UE_LOAD_RATE_DENY = 'ue_load_rate_deny',
  UE_BOOK_SUCCESS = 'ue_book_success',
  UE_BOOK_FAILED = 'ue_book_failed',

  UE_START_TRIP = 'ue_start_trip',
  UE_GEO_TRACKING = 'ue_geo_tracking',
  UE_GEOFENCE_ANNOUNCEMENT = 'ue_geofence_announcement',
  //myloads
  SV_VIEW_MYLOADS = 'sv_view_myloads',
  SV_VIEW_CARRIER_ASSIGNED = 'sv_view_carrier_assigned',
  SV_ASSIGN_DRIVER = 'sv_assign_driver',
  UE_ASSIGN_DRIVER_SUCCESS = 'ue_assign_driver_success',
  UE_MYLOADS_NORESULTS_NEWSEARCH = "ue_myloads_noresults_newsearch",

  SV_VIEW_DRIVER_ASSIGNED = 'sv_view_driver_assigned',
  //In Transit
  SV_VIEW_IN_TRANSIT = 'sv_view_in_transit',
  SV_VIEW_RECENTLY_DEL = 'sv_view_recently_del',

  SV_VIEW_CARRIER_TENDERED = 'sv_view_carrier_tendered',

  //Load Posting
  SV_LOAD_DETAILS = 'sv_load_details',
  UE_VIEW_LOAD = 'ue_view_load',
  UE_WATCH_LOAD = 'ue_watch_load',
  UE_VIEW_LOAD_TERMS = 'ue_view_load_terms',
  UE_VIEW_LOAD_CALL_US = 'ue_view_load_call_us',
  UE_LOAD_VIEW_CALL = 'ue_load_view_call',
  UE_CONTACT_TO_BOOK = 'ue_contact_to_book',
  // Load Details
  SV_VIEW_SHIPMENT = 'sv_view_shipment',
  //Manage Profile
  SV_MANAGE_PROFILE = 'sv_manage_profile',
  SV_VIEW_MY_PROFILE = 'sv_view_my_profile',
  SV_VIEW_CARRIER_PROFILE = 'sv_view_carrier_profile',
  SV_MANAGE_USERS = 'sv_manage_users',
  SV_MANAGE_CAPACITY = 'sv_manage_capacity',
  SV_MANAGE_CAPACITY_ADDEDIT = 'sv_manage_capacity_addedit',
  UE_MANAGE_CAPACITY_SUCCESS = 'ue_manage_capacity_success',
  UE_MANAGE_CAPACITY_FAILED = 'ue_manage_capacity_failed',
  //More Menu
  SV_MORE_MENU = 'sv_more_menu',
  // ShipmentStopDetails
  UE_STOP_UPDATE_SUCCESS = 'ue_stop_update_success',
  UE_STOP_UPDATE_FAILURE = 'ue_stop_update_failure',
  UE_COMPLETE_TRIP = 'ue_complete_trip',
  SV_LATE_REASON_CODE = "sv_late_reason_code",
  UE_LATE_REASON_CODE_SUBMIT = "ue_late_reason_code_submit", 
  //Map view
  SV_LOAD_DETAILS_MAP = 'sv_load_details_map',
  UE_LOAD_DETAILS_MAP = 'ue_load_details_map',
  // Reference
  SV_VIEW_REFERENCE = 'sv_view_reference',
  UE_SORT_PRICE = 'ue_sort_price',
  UE_SORT_DISTANCE = 'ue_sort_distance',
  UE_FAVOURITE_SEARCH = 'ue_favourite_search',
  UE_CONCURRENT_BUY = 'ue_concurrent_buy',
  UE_LOAD_ON_HOLD = 'ue_load_on_hold',
  UE_BUY_IN_PROGRESS = 'ue_buy_in_progress',
  UE_ASSIGN_DRIVER = 'ue_assign_driver',
  UE_CONFIRM_ASSIGNMENT = 'ue_confirm_assignment',
  UE_FILTER_USAGE = 'ue_filter_usage',
  UE_START_TRIP_FAIL = 'ue_start_trip_fail',
  SV_LOAD_ASSIGNMENT = 'sv_load_assignment',
  UE_SATELLITE_VIEW = 'ue_satellite_view',
  UE_MAP_VIEW = 'ue_map_view',
  UE_EDIT_PROFILE = 'ue_edit_profile',
  UE_SAVE_PROFILE = 'ue_save_profile',
  UE_DELINK_CARRIER = 'ue_delink_carrier',
  UE_CHANGE_PASSWORD = 'ue_change_password',
  UE_VIEW_USER = 'ue_view_user',
  UE_EDIT_USER = 'ue_edit_user',
  UE_SAVE_USER_CHANGES = 'ue_save_user_changes',
  UE_ADD_NEW_USER = 'ue_add_new_user',
  UE_TRANSFER_USER = 'ue_transfer_user',
  UE_NEW_USER_ADDED = 'ue_new_user_added',
  UE_DELETE_CAPACITY = 'ue_delete_capacity',
  SV_MORE_FAQ = 'sv_more_faq',
  SV_MORE_VIDEO = 'sv_more_video',
  SV_MORE_CONTACT = 'sv_more_contact',
  SV_MORE_LEARN = 'sv_more_learn',
  SV_MORE_LEGAL = 'sv_more_legal',
  UE_FEEDBACK_MISSED = 'ue_feedback_missed',
  UE_FEEDBACK_SUCCESS = 'ue_feedback_success',
  UE_FEEDBACK_FAILURE = 'ue_feedback_failure',
  UE_LOGOUT = 'ue_logout',
  UE_NOTIFICATION_VIEW = 'ue_notification_view',
  UE_NOTIFICATION_RECEIVED = 'ue_notification_received',
  UE_REGISTRATION_LOGOUT = 'ue_registration_logout',
  UE_RECOMMENDED_SIMILAR_LOADS = "ue_recommended_similar_loads",
  UE_CANCEL_GEO_TRACKING_PERMISSION = "ue_cancel_geo_tracking_permission",
  UE_MY_DRIVERS = "ue_my_drivers",

  //Viewed Loads
  UE_RECOMMENDED_VIEW = "ue_recommended_view",
  UE_SEARCH_VIEW = "ue_search_view",
 
  //Recently delivered 
  UE_PAYMENT_STATUS_REDIRECT = "ue_payment_status_redirect",
  UE_LOAD_AGREED_RATE = "ue_load_agreed_rate",
  UE_SHIPMENT_EXECUTION_COMMODITIES_VIEW = "ue_shipment_execution_commodities_view",
  UE_LOAD_POSTING_COMMODITIES_VIEW = "ue_load_posting_commodities_view",

  //Top Recommendation
  UE_SEARCH_HEADER_RECOMMENDED_LOAD_DETAILS="ue_search_header_recommended_load_details",

  //User Deletion
  UE_ACCOUNT_DELETE_ATTEMPT = "ue_account_delete_attempt",
  UE_ACCOUNT_DELETE_SUCCESSFUL = "ue_account_delete_successful",
  UE_DELETE_ACCOUNT_CANCEL = "ue_delete_account_cancel",
  UE_DELETE_ACCOUNT_SURVEY = "ue_delete_account_survey",
  UE_DELETE_ACCOUNT = "ue_delete_account",

  //User Preference
  SV_VIEW_PREFERENCES = "sv_view_preferences",
  UE_PREFERENCES_SAVE = "ue_preferences_save",

  //Reload 
  UE_SEARCH_RELOAD = "ue_search_reload",
  UE_RECOMMENDED_RELOAD = "ue_recommended_reload",
  UE_CAPACITY_RELOAD = "ue_capacity_reload",
  UE_MYLOADS_RELOAD = "ue_myloads_reload",

  // Similar Loads 
  UE_SIMILAR_MYLOADS = "ue_myloads_similar_route",

  SV_INVOICE_CHOICE = "sv_invoice_choice",
  SV_INVOICE_TRAILER_CONFIRMATION = "sv_invoice_trailer_confirmation",
  UE_INVOICE_TRAILER_CONFIRMED = "ue_invoice_trailer_confirmed",
  UE_INVOICE_GENERATION_SUCCESS = "ue_invoice_generation_success",
  UE_INVOICE_GENERATION_FAILURE = "ue_invoice_generation_failure",
  UE_INVOICE_UPLOAD_SUCCESS = "ue_invoice_upload_success",
  UE_INVOICE_UPLOAD_FAILURE = "ue_invoice_upload_failure",

  UE_FUEL_SAVINGS_REDIRECTION = "ue_fuel_savings_redirection",

  SV_ELD_SIGNUP = "sv_eld_signup",
  UE_ELD_SIGNUP_ACCEPTANCE = "ue_eld_signup_acceptance",
  UE_ELD_SIGNUP_DENIAL = "ue_eld_signup_denial",
  UE_ELD_SIGNUP_LINK_CLOSED = "ue_eld_signup_link_closed",
  UE_NO_NEXT_ROUTE = "ue_no_next_route",
  UE_NEED_NEXT_ROUTE = "ue_need_next_route",
  UE_NEED_NEXT_ROUTE_LATER = "ue_need_next_route_later",
  UE_TRAILER_LEASE = "ue_trailer_lease",
  UE_TRAILER_LEASE_REDIRECTION = "ue_trailer_lease_redirection",
  CONTACT_US_CARRIER_TENDERED = 'contact_us_carrier_tendered',
  CONTACT_US_CARRIER_ASSIGNED = 'contact_us_carrier_assigned',
  CONTACT_US_IN_TRANSIT = 'contact_us_in_transit',
  CONTACT_US_RECENTLY_DELIVERED = 'contact_us_recently_delivered',
  CONTACT_US_DELIVERED_NEEDS_PPWK = 'contact_us_delivered_needs_pprwk',
  CONTACT_US_DELIVERED_WITH_PPWK = 'contact_us_delivered_with_pprwk',
  CONTACT_US_DRIVER_ASSIGNED = 'contact_us_driver_assigned',
  // Carrier Tendered
  CARRIER_TENDERED_ACCEPT = "ue_carrier_tendered_accept",
  CARRIER_TENDERED_ACCEPT_CONFIRMED = "ue_accept_load_confirmed",
  CARRIER_TENDERED_ACCEPT_DENIED = "ue_accept_load_denied",
  CARRIER_TENDERED_DECLINE = "ue_carrier_tendered_decline",
  SV_ADD_REFERENCE = "sv_add_reference",
  UE_ADD_REFERENCE_CONFIRM = 'ue_add_reference_confirm',
  UE_ADD_REFERENCE_CANCEL = 'ue_add_reference_cancel',
  UE_ADD_REFERENCE_SUCCESS = 'ue_add_reference_success',
  UE_ADD_REFERENCE_FAILURE = 'ue_add_reference_failure',
  UE_OOPS_PAGE_OCCURRENCE = "ue_oops_page_occurrence",
  SV_PRE_BOOK_NOW_MODAL = "sv_pre_book_now_modal",
  UE_PRE_BOOK_NOW_ACCEPTANCE = "ue_pre_book_now_acceptance",
  UE_PRE_BOOK_NOW_CANCELLATION = "ue_pre_book_now_cancellation",
  SV_ROLE_SELECTION_CONFIRMATION_MODAL = "sv_role_selection_confirmation_modal",
  UE_ROLE_SELECTION_CONFIRM = "ue_role_selection_confirm",
  UE_ROLE_SELECTION_DECLINE = "ue_role_selection_decline"
}

export enum SCREEN {
  REGISTRATION = "registration",
  NEWCARRIERREQUEST = "newcarrierrequest",
  HOME = "home",
  GET_STARTED = "get-started",
  SHIPMENT_DETAILS = "shipment_details",
  DELIVERED_SHIPMENT_DETAILS = "delivered_shipment_details",
  //Search
  SEARCH_FILTER = 'search_filter',
  SEARCH_RESULT = 'search_result',
  SEARCH = 'search',
  //Book It Now
  LOAD_DETAILS = 'load_details',
  LOAD_DETAILS_RATE = 'load_details_rate',
  //myloads
  MYLOADS = 'myloads',
  MYLOADS_CARRIER_TENDERED = 'myloads_carrier_tendered',
  MYLOADS_CARRIER_ASSIGNED = 'myloads_carrier_assigned',
  MYLOADS_DRIVER_ASSIGNMENT = 'myloads_driver_assignment',
  MYLOADS_IN_TRANSIT = 'myloads_in_transit',
  MYLOADS_RECENTLY_DELIVERED = 'myloads_recently_delivered',
  MYLOADS_DELIVERED_NEEDS_PPWK = 'myloads_delivered_needs_ppwk',
  MYLOADS_DELIVERED_WITH_PPWK = 'myloads_delivered_with_ppwk',
  CONTACT_US_DELIVERED_NEEDS_PPWK = 'myloads_delivered_needs_pprwk',
  CONTACT_US_DELIVERED_WITH_PPWK = 'myloads_delivered_with_pprwk',
  MYLOADS_DRIVER_ASSIGNED = 'myloads_driver_assigned',
  MYLOADS_DOCUMENT = "myloads_document",
  MYLOADS_DOCUMENT_VIEW = "myloads_document_view",
  // Load details
  //Manage Profile
  MANAGE_PROFILE = 'manage_profile',
  MY_PROFILE = 'my_profile',
  CARRIER_PROFILE = 'carrier_profile',
  MANAGE_USERS = 'manage_users',
  MANAGE_CAPACITY = 'manage_capacity',
  MANAGE_CAPACITY_ADDEDIT = 'manage_capacity_addedit',
  //More Menu
  MORE_MENU = 'more_menu',
  //Map view
  LOAD_DETAILS_MAP = 'load_details_map',
  //Reference
  MYLOADS_NEEDS_PPWK = 'myloads_needs_ppwk',
  HOME_SORT_PRICE = 'home_sort_price',
  HOME_SORT_DISTANCE = 'home_sort_distance',

  //Added for LPE Feedback
  RECOMMENDED_SIMILAR_LOAD = 'recommended_similar_load',

  SEARCH_FAVOURITE = 'search_favourite',
  BUY_CONCURRENT = 'buy_concurrent',
  BUY_LOAD_ON_HOLD = 'buy_load_on_hold',
  BUY_IN_PROGRESS = 'buy_in_progress',
  CA_ASSIGN_DRIVER = 'ca_assign_driver',
  CA_CONFIRM_ASSIGNMENT = 'ca_confirm_assignment',
  DA_DRIVER_FILTER = 'da_driver_filter',
  DA_START_TRIP_FAILURE = 'da_start_trip_failure',
  ML_LOAD_ASSIGNMENT = 'ml_load_assignment',
  ML_START_TRIP = 'ml_start_trip',
  EX_SATELLITE_VIEW = 'ex_satellite_view',
  EX_MAP_VIEW = 'ex_map_view',
  MP_EDIT_PROFILE = 'mp_edit_profile',
  MY_PROFILE_EDIT = 'my_profile_edit',
  DELETE_ACCOUNT_SURVEY_REDIRECTION = "delete_account_survey_redirection",
  MP_SAVE_PROFILE = 'mp_save_profile',
  MP_DELINK_CARRIER = 'mp_delink_carrier',
  MP_CHANGE_PASSWORD = 'mp_change_password',
  MANAGE_USER = 'manage_user',
  MU_VIEW_USER = 'mu_view_user',
  MU_EDIT_USER = 'mu_edit_user',
  MU_DELINK_CARRIER = 'mu_delink_carrier',
  MU_SAVE_CHANGES = 'mu_save_changes',
  MU_ADD_NEW_USER = 'mu_add_new_user',
  MU_TRANSFER_USER = 'mu_transfer_user',
  MU_USER_ADDED = 'mu_user_added',
  MC_DELETE_CAPACITY = 'mc_delete_capacity',
  MORE_FAQ = 'more_faq',
  MORE_VIDEO_WALKTHROUGH = 'more_video_walkthrough',
  MORE_CONTACT_OPTION = 'more_contact_option',
  MR_LEARN_ABOUT_SNI = 'mr_learn_about_sni',
  MORE_LEGAL = 'more_legal',
  MR_STORE_FEEDBACK_MISSED = 'mr_store_feedback_missed',
  MR_STORE_FEEDBACK_SUCCESS = 'mr_store_feedback_success',
  MR_STORE_FEEDBACK_FAILURE = 'mr_store_feedback_failure',
  MR_LOGOUT = 'mr_logout',
  FCM_NOTIFICATION_VIEW = 'fcm_notification_view',
  FCM_NOTIFICATION_RECEIVED ='fcm_notification_received',
  REGISTRATION_LEAKAGE = 'registration_leakage',
  LOAD_DETAILS_AGREED_RATE = "load_details_agreed_rate",
  MANAGE_USER_PREFERENCES = "manage_user_preferences",
  RECOMMENDATION_HOME = "recommendation_home",
  RECOMMENDATION_SEARCH = "recommendation_search",
  SEARCH_RESULTS = "search_results",
  CAPACITY_RESULTS = "capacity_results",
  MYLOADS_DELIVERED = "myloads_delivered",
  DELIVERED_WITH_PPWK = "myloads_delivered_ppwk",
  WEB_LEFT_NAV_RIBBON = "web_left_nav_ribbon",
  DRIVER_ASSIGN_ELD_SIGNUP = "driver_assign_eld_signup",
  RELOAD_DRIVER = "reload_driver",
  LATE_REASON_CODE_MODAL = "late_reason_code_modal",
  // Carrier Tendered
  ACCEPT_LOAD = "my_load_accept_load",
  CARRIER_TENDERED = "my_load_carrier_tendered",
  ADD_REFERENCE_MODAL = "add_reference_modal",
  SCREEN_REFERENCE_DIALOG = "screen_reference_dialog",
  OOPS_PAGE = "oops_page",
  PRE_BOOK_NOW_MODAL = "pre_book_now_modal",
  SAMEDAY_PICKUP_MODAL = "same_day_pickup_modal",
  ROLE_SELECTION_CONFIRMATION_MODAL = "role_selection_confirmation_modal"
}

export enum TAB {
  RECOMMENDED = 'recommended',
  WATCHED = 'watched',
  NEW = 'new',
  RECENT = 'recent',
  FAVORITE = 'favorite',
  SEARCHED = 'searched',
  CARRIER_ASSIGNED = 'CarrierAssigned',
  DRIVER_ASSIGNED = 'DriverAssigned',
  IN_TRANSIT = 'InTransit',
  RECENTLY_DELIVERED_LOADS = 'Delivered',
  MANAGE_CAPACITY = 'manage-capacity',
  MYLOAD = 'MyLoad',
  ADD_USER = "Add User",
  MANAGE_USER ="Manage User"
}
